/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseModuleSubmissionResponseData } from './genericApiResponseModuleSubmissionResponseData';
import type { GenericApiResponseModuleSubmissionResponseMessage } from './genericApiResponseModuleSubmissionResponseMessage';
import type { GenericApiResponseModuleSubmissionResponsePagination } from './genericApiResponseModuleSubmissionResponsePagination';
import type { GenericApiResponseModuleSubmissionResponseError } from './genericApiResponseModuleSubmissionResponseError';

export interface GenericApiResponseModuleSubmissionResponse {
  data?: GenericApiResponseModuleSubmissionResponseData;
  message?: GenericApiResponseModuleSubmissionResponseMessage;
  pagination?: GenericApiResponseModuleSubmissionResponsePagination;
  error?: GenericApiResponseModuleSubmissionResponseError;
  statusCode?: number;
}
